import * as Common from "../../commons/common"

export class Sheet {
  sheet_group_key: number
  nendo: number
  exec_date: string
  grade: number
  kind: number
  name: string
  isSelected: boolean = false

  constructor(sheet: any){
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.exec_date = sheet.exec_date;
    this.grade = sheet.grade;
    this.name = sheet.name;
  }
}

export class Condition{
  sheet_group_key: string = ""
  nendo: string = ""
  month: string = ""
  grade: string = ""
}